export default __webpack_public_path__ + "media/images/home/slide_hot_spring_2022_sm-e0edeb6db9608fa03b6687ab16866e71.jpg";